import { formatHeroCurrency, getComparableOfferPrice } from './simpleProductPageShared';
import {
  formatVerificationDate,
  getOfferListPresentation,
  hasUsableOfferUrl,
  isCurrentVerifiedPurchasableOffer,
  selectCurrentVerifiedBest,
  sortCustomerOffers,
} from '../../domain/offerFreshness';

export function hasUsableAffiliateUrl(offer) {
  return hasUsableOfferUrl(offer);
}

export function isEligibleVerifiedOffer(offer, options = {}) {
  const { now, ...priceOptions } = options;
  return isCurrentVerifiedPurchasableOffer(offer, now, priceOptions);
}

export function sortVerifiedOffers(offers, options = {}) {
  return sortCustomerOffers(offers, options);
}

export function getBestVerifiedOffers(offers, options = {}) {
  return selectCurrentVerifiedBest(offers, options).tied;
}

export function getBestVerifiedOffer(offers, options = {}) {
  return selectCurrentVerifiedBest(offers, options).primary;
}

export function getCurrentVerifiedSelection(offers, options = {}) {
  return selectCurrentVerifiedBest(offers, options);
}

export function getPricePageModelLabel(product) {
  const slug = String(product?.slug || '').trim();
  const slugMatch = slug.match(/(lvs\d+[a-z0-9]*)$/i);
  if (slugMatch) return slugMatch[1].toUpperCase();

  const name = String(product?.name || '').trim();
  const nameMatch = name.match(/\b(LVS\d+[A-Z0-9]*)\b/i);
  if (nameMatch) return nameMatch[1].toUpperCase();

  return name || 'Product';
}

export function buildPricePageDocumentTitle(product) {
  const brand = String(product?.brand || 'Garmin').trim() || 'Garmin';
  const model = getPricePageModelLabel(product);
  return `${brand} ${model} Prices & Current Retailer Offers | Angler Built`;
}

export function formatPricePageFreshness(offer) {
  const dateLabel = formatVerificationDate(offer);
  return dateLabel ? `Checked ${dateLabel}` : null;
}

export function formatPricePageAvailability(offer) {
  return getOfferListPresentation(offer).availabilityLabel;
}

export function formatMsrpReference(msrp) {
  const formatted = formatHeroCurrency(msrp);
  return formatted ? `${formatted} MSRP · reference price` : null;
}

export { getComparableOfferPrice, getOfferListPresentation };
